export default defineNuxtRouteMiddleware(() => {
    const auth = useAuthStore();
    if (!auth.isLogged) return;

    if (auth.isSuperUser) return;

    if (auth.isAdmin) {
        return navigateTo('/tat/admin/Dashboard');
    }

    return navigateTo('/');
});
